module.exports = __webpack_public_path__ + "static/media/joeking-6.80bee2c8.jpg";